export const FORM_CONSTS = {
    NAME: "name",
    SHAREBY: "shareBy",
    SHARED_TEAMS: "sharedTeams",
    SORT: "sortBy",
    ORDER: "order",
    KEYTYPE: "keyType",
    CONDITIONS: "dynamicConditions",
};
